import React, { useEffect, useCallback, useState } from 'react';
import img from '../assets/plate-method.png';

const cardItems = [
    {
        id: 1,
        title: 'Eat Regular Meals',
        src: img,
        copy: "Maintaining steady blood sugar levels is crucial for people with prediabetes so it's important to eat small meals at regular intervals. Typically, it is recommended to eat three properly portioned meals at regular intervals throughout the day. The CDC recommends the plate method for properly portioned meals. Half the plate should be filled with non-starchy vegetables, a quarter with a lean protein, and the last quarter with a grain or starchy food. "
    },
    {
        id: 2,
        title: 'Second',
        src: 'http://placeimg.com/640/480/any',
        copy: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    },
    {
        id: 3,
        title: 'Third',
        src: 'http://placeimg.com/640/480/any',
        copy: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    },
    {
        id: 4,
        title: 'Fourth',
        src: 'http://placeimg.com/640/480/any',
        copy: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    },
];

function determineClasses(indexes, cardIndex) {
    if (indexes.currentIndex === cardIndex) {
        return 'active';
    } else if (indexes.nextIndex === cardIndex) {
        return 'next';
    } else if (indexes.previousIndex === cardIndex) {
        return 'prev';
    }
    return 'inactive';
}


const Carousel = () => {
    const [indexes, setIndexes] = useState({
        previousIndex: 0,
        currentIndex: 0,
        nextIndex: 1,
    });

    const handleCardTransition = useCallback(() => {
        if (indexes.currentIndex >= cardItems.length - 1) {
            setIndexes({
                previousIndex: cardItems.length - 1,
                currentIndex: 0,
                nextIndex: 1,
            });
        } else {
            setIndexes((prevState) => ({
                previousIndex: prevState.currentIndex,
                currentIndex: prevState.currentIndex + 1,
                nextIndex: prevState.currentIndex + 2 === cardItems.length ? 0 : prevState.currentIndex + 2,
            }));
        }
    }, [indexes.currentIndex]);

    const handleBackTransition = useCallback(() => {
        if (indexes.currentIndex <= 0) {
            setIndexes({
                previousIndex: 0,
                currentIndex: cardItems.length - 1,
                nextIndex: cardItems.length - 2,
            });
        } else {
            setIndexes((prevState) => ({
                previousIndex: prevState.currentIndex,
                currentIndex: prevState.currentIndex - 1,
                nextIndex: prevState.currentIndex - 2 === 0 ? 0 : prevState.currentIndex - 2,
            }));
        }
    }, [indexes.currentIndex]);

    return (
        <div className="container">
            <button onClick={handleBackTransition}>Prev</button>
            <ul className="carousel">
                {cardItems.map((card, index) => (
                    <li
                        key={card.id}
                        className={`card ${determineClasses(indexes, index)}`}
                    >
                        <h2>{card.title}</h2>
                        <img src={card.src} width="75%" height="250px"></img>
                        <p>{card.copy}</p>
                    </li>
                ))}
            </ul>
            <button onClick={handleCardTransition}>Next</button>
        </div>
    );
}

export default Carousel;